var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotted2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 101,
    viewBox: "0 0 135 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 5.00024)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 5)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 15.1829)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 15.1833)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 25.3676)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 25.3672)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 35.5508)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 35.5504)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 45.7336)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 45.7335)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 55.9175)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 55.9174)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 60.6842)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 60.6843)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 70.8687)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 70.8676)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 108.91 70.8676)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 81.0511)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.395 81.0514)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 108.91 81.0514)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.392 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 108.91 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 97.4258 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 85.9421 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 74.4583 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 131.877 96.0022)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 120.393 96.0013)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 108.91 96.0013)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 97.4265 96.0013)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 85.9426 96.0013)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 74.459 96.0013)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 63.1846 85.819)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 51.7021 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 40.2183 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 28.7344 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 17.2517 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 5.76685 85.8181)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 63.1848 96.0021)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 51.7024 96.0012)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 40.2185 96.0012)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 28.7349 96.0012)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 17.252 96.0012)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(-1 0 0 1 5.76709 96.0012)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 31.8145 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 43.2993 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 54.782 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 66.2659 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 77.7495 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 89.2334 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 31.8149 4.94714)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 43.2986 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 54.7812 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 66.2651 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 77.749 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 89.2327 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 100.507 15.1304)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 111.99 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 123.473 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 134.957 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 100.507 4.94727)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 111.989 4.94812)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 123.473 4.94812)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 134.957 4.94812)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 85.8724)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 85.8727)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 75.6898)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 75.6893)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 65.5051)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 65.5055)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 55.3219)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 55.3223)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 45.139)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 45.1392)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 34.9552)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 34.9553)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 25.1339)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 25.1338)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 14.9495)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 14.9506)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 22.9675 14.9506)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 0 4.76697)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 11.4827 4.76672)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 4.76673,
    height: 4.76673,
    transform: "matrix(1 0 0 -1 22.9675 4.76672)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotted2);
export default __webpack_public_path__ + "static/media/dotted2.d0d5c1e0fcc08b0a3a2340588009b151.svg";
export { ForwardRef as ReactComponent };